import React from "react";
import SiteContent from "../components/site-items/SiteContent/SiteContent";
import Navbar from "../parts/Navbar/Navbar";
import Footer from "../parts/Footer/Footer";
import PageWrapper from "../components/page-items/PageWrapper/PageWrapper";
import LoginForm from "../sections/Login/LoginForm/LoginForm";
import PageContent from "../components/page-items/PageContent/PageContent";
import PageHeader from "../components/page-items/PageHeader/PageHeader";
import SectionBody from "../components/section-items/SectionBody/SectionBody";

const LoginPage = () => {
    return (
        <SiteContent>
            <Navbar/>
            <PageWrapper>
                <PageContent>
                    <PageHeader header={'Admin'}/>
                    <SectionBody>
                        <LoginForm/>
                    </SectionBody>
                </PageContent>
            </PageWrapper>
            <Footer/>
        </SiteContent>
    );
};

export default LoginPage;
